import PopularSearchBlock from './PopularSearchBlock.vue'

export default PopularSearchBlock
